/**
 * This file is responsible for handling the service calls for the contacts
 */
import store from "../store";
import {
	callAPI,
	chameau,
	GATEWAY_PROXY,
	METHODS,
} from "utils/apiUtils";

export function getEmailAPIStatisticsService(
	options = { startTime: "", endTime: "", tags: ""},
	successCallback = () => { },
	failureCallback = () => { }
) {
	const {...restOptions } = options;
	callAPI(
		{
			url: GATEWAY_PROXY + `/v2/reports/emails`,
			method: METHODS.get,
			query: {
				...chameau(restOptions),
				account_id: store.getState().global.account.id,
			},
		},
		successCallback,
		failureCallback
	);
}


export function getEmailAPIActivityLogsService(
	options = { startTime: "", endTime: "", tags: ""},
	successCallback = () => { },
	failureCallback = () => { }
) {
	const {...restOptions } = options;
	callAPI(
		{
			url: GATEWAY_PROXY + `/v2/logs/emails`,
			method: METHODS.get,
			query: {
				...chameau(restOptions),
				account_id: store.getState().global.account.id,
			},
		},
		successCallback,
		failureCallback
	);
}